export var booleanEquals = function booleanEquals(value1, value2) {
  return value1 === value2;
};